import { z } from 'zod'
import { expectedPaymentResponseSchema } from './expected-payment-response.schema'
import { paidPaymentResponseSchema } from './paid-payment-response.schema'
import { projectedDividendResponseSchema } from './projected-dividend-response.schema'

export const paymentsResponseSchema = z.object({
  planned: z.array(expectedPaymentResponseSchema),
  paid: z.array(paidPaymentResponseSchema),
  // forecast dividends beyond T-Bank's announced horizon (next 12 months)
  projected: z.array(projectedDividendResponseSchema),
})

export type PaymentsResponseDto = z.infer<typeof paymentsResponseSchema>
